import { tap, map, concatMap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { HttpClient } from '@angular/common/http';
import { Subject, Observable } from 'rxjs';
import { Pagination } from '@core/models/pagination.model';
import { DefaultDataService, HttpUrlGenerator } from '@ngrx/data';
import { Injectable } from '@angular/core';
import { Campaign } from '@core/models/campaign.model';

@Injectable()
export class CampaignDataService extends DefaultDataService<Campaign>  {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
      super('Campaign', http, httpUrlGenerator, { root: '' });
  }

  getAll(): Observable<Campaign[]> {
    return this.http.get<ApiResponse>('/campaign').pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getWithQuery(pageParam: string): Observable<Campaign[]>{
    return this.http.get<ApiResponse>(`/campaign${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  getById(id: number): Observable<Campaign>{
    return this.http.get<ApiResponse>(`/campaign/${id}`).pipe(
      map(res => res.data.rows)
    );
  }

  add(campaign: Campaign): Observable<Campaign>{
    return this.http.post<ApiResponse>(`/campaign`, campaign).pipe(
      tap( res => this.messages$.next(res.message)),
      concatMap((entity) => this.http.get(`/campaign/${entity.data.rows.id}`).pipe(
        map((row: ApiResponse) => row.data.rows)
      ))
    );
  }

  getCampaignMember(pageParam: any): Observable<any>{
    return this.http.get<ApiResponse>(`/campaign/getcampaignmember${pageParam}`).pipe(
      tap(res => this.paginationInit(res)),
      map(res => res.data.rows)
    );
  }

  private paginationInit(res: any) {
    if(res) {
      this.pagination = res.data.paginations;
    }
  }
}
